import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Table } from "../../../Table/Table";
import Loading from "../../../Loadings/LoadingTable";
import { MdDeleteForever } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import Button from "../../../Button/Button";
import { useGetPropertyListLevelTow } from "../../../../hooks/useContent";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  ContentUnitModal,
  RefreshTableLevelSecond,
} from "../../../../shared/content-unit";
import { ButtonContainer } from "../../ProductCategory/LevelFirst/LevelFirstTable";
import { RenderTooltip } from "../../../Tooltip/Tooltip";

function Level2Table() {
  const refresh = useRecoilValue(RefreshTableLevelSecond);

  const [pageNumber, setPageNumber] = useState(1);
  const [search, setSearch] = useState("");

  const { data, isLoading, refetch, hasNextPage, fetchNextPage } =
    useGetPropertyListLevelTow(pageNumber, search);

  const [moduals, setModuals] = useRecoilState(ContentUnitModal);
  let categoryList = data?.data?.feature_values;
  let pageCount = data?.pages[0]?.data?.NumberList;

  useEffect(() => {
    refetch(pageNumber, search);
    categoryList = [];
  }, [refresh]);

  const headerTitle = [
    "#",
    "والد سطح اول",
    "نام دسته بندی",
    "نام دسته بندی انگلیسی",
    "نام دسته بندی عربی",
    "عملیات",
  ];

  const handleDeleteCatergory = (category) => {
    setModuals({
      ...moduals,
      deletePropertyLevel2: { value: category, isShow: true },
    });
  };

  const handleUpdateCategory = (item) => {
    setModuals({
      ...moduals,
      updatePropertyLevel2: { value: item, isShow: true },
    });
  };

  // handle next page
  const handleNext = () => {
    if (pageNumber < pageCount) setPageNumber((prevState) => prevState + 1);
  };

  // handle previos page
  const handlePrevios = () => {
    if (pageNumber === 1) {
      setPageNumber(1);
    } else {
      setPageNumber((prevState) => prevState - 1);
    }
  };

  useEffect(() => {
    let fetching = false;
    const onScroll = async (event) => {
      const { scrollHeight, scrollTop, clientHeight } =
        event.target.scrollingElement;
      if (!fetching && scrollHeight - scrollTop <= clientHeight * 2.5) {
        fetching = true;
        if (hasNextPage) await fetchNextPage();
        fetching = false;
      }
    };
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [fetchNextPage, hasNextPage]);

  let i = 0;

  const items = data ? (
    data?.pages?.map((page) =>
      page?.data?.feature_values?.map((item, index) => {
        return (
          <tr key={index}>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {(i += 1)}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.LableProperties ? item?.LableProperties : ""}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.AmountFeatureValues ? item?.AmountFeatureValues : ""}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.AmountFeatureValuesEnglish
                  ? item?.AmountFeatureValuesEnglish
                  : ""}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.AmountFeatureValuesLanguage
                  ? item?.AmountFeatureValuesLanguage
                  : ""}
              </span>
            </td>
            <td>
              <ButtonContainer>
                <RenderTooltip title={"حذف ویژگی"}>
                  <Button
                    size="12px"
                    bgColor="#C82333"
                    small="40px"
                    color="#fff"
                    style={{
                      marginLeft: "1rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onclick={(e) => {
                      handleDeleteCatergory(item);
                    }}
                  >
                    <MdDeleteForever size={25} />
                  </Button>
                </RenderTooltip>
                <RenderTooltip title={"ویرایش ویژگی"}>
                  <Button
                    size="12px"
                    bgColor="#0D6EFD"
                    small="40px"
                    color="#fff"
                    className="mr-2"
                    onclick={(e) => {
                      handleUpdateCategory(item);
                    }}
                  >
                    <FiEdit size={20} />
                  </Button>
                </RenderTooltip>
              </ButtonContainer>
            </td>
          </tr>
        );
      })
    )
  ) : (
    <Loading />
  );

  return (
    <CategoryTableStyle>
      <Table
        headerTitle={headerTitle}
        title={`ویژگی هایی که تا کنون برای سطح 2 ایجاد کرده اید: ${
          pageCount ? pageCount : ""
        }`}
        items={items}
        setSearch={setSearch}
      />
    </CategoryTableStyle>
  );
}

const CategoryTableStyle = styled.div`
  width: 100%;
  margin-top: 1rem;

  .slider-image-table {
    width: 90px;
    height: 60px;
    object-fit: cover;
    border-radius: 0.5rem;
  }
`;

export default Level2Table;
